import { useEffect, useState } from "react";
import { ChromeTab, ChromeWindow } from "@/types";

declare global {
  interface Window {
    chrome: typeof chrome;
  }
}

const MOCK_WINDOWS: ChromeWindow[] = [
  {
    id: "1150048880",
    name: "Window 1150048880",
    tabs: [
      {
        id: "1",
        title: "Inbox (794) - jokemeblack@gmail.com - Gmail",
        url: "https://mail.google.com/mail/u/0/#inbox",
        favIconUrl: "https://ssl.gstatic.com/ui/v1/icons/mail/rfr/gmail.ico",
      },
      {
        id: "2",
        title: "Venture Capital is Dead - nishanthravik@gmail.com - Gmail",
        url: "https://mail.google.com/mail/u/2/#inbox/FMfcgzQbfBqJgggddldFlMMQGhgWnsWQ",
        favIconUrl: "https://ssl.gstatic.com/ui/v1/icons/mail/rfr/gmail.ico",
      },
      {
        id: "3",
        title: "localhost / localhost / hintword / collections | phpMyAdmin 5.1.3",
        url: "http://localhost/pmadmin/index.php?route=/sql&db=hintword&table=collections&pos=0",
        favIconUrl: "http://localhost/pmadmin/favicon.ico",
      },
      {
        id: "4",
        title: "(5) Facebook",
        url: "https://www.facebook.com/",
        favIconUrl: "https://static.xx.fbcdn.net/rsrc.php/y1/r/ay1hV6OlegS.ico",
      },

    ],
  },
  {
    id: "2",
    name: "Window 2",
    tabs: [
      {
        id: "5",
        title: "Online Shopping Site for Mobiles, Electronics, Furniture, Grocery, Lifestyle, Books & More. Best Offers!",
        url: "https://www.flipkart.com/",
        favIconUrl: "https://static-assets-web.flixcart.com/batman-returns/batman-returns/p/images/logo_lite-cbb357.png",
      },
      {
        id: "6",
        title: "Groww - Online Demat, Trading and Direct Mutual Fund Investment in India",
        url: "https://groww.in/",
        favIconUrl: "https://groww.in/favicon32x32-groww.ico",
      },
      {
        id: "7",
        title: "CRED. not everyone gets it.",
        url: "https://cred.club/",
        favIconUrl: "https://web-images.credcdn.in/v2/_next/assets/icons/logo.png",
      }
    ],
  },
];

export function useAllWindowsTabs() {
  const [windows, setWindows] = useState<ChromeWindow[]>([]);

  useEffect(() => {
    if (import.meta.env.MODE === "development") {
      setWindows(MOCK_WINDOWS);
    } else if (window.chrome?.windows && typeof window.chrome.windows.getAll === 'function') {
      window.chrome.windows.getAll({ populate: true }, (winArr: any[]) => {
        setWindows(
          winArr.map(win => ({
            id: String(win.id),
            name: `Window ${win.id}`,
            tabs: (win.tabs || []).map((tab: any) => ({
              id: String(tab.id),
              title: tab.title || '',
              url: tab.url || '',
              favIconUrl: tab.favIconUrl || '',
            })),
          }))
        );
      });
    }
  }, []);

  return windows;
} 